import { createUseStyles } from "react-jss";
import { THEME } from "./theming";
export const useIconClasses = (iconType, color, iconOnly) => {
    const useStyles = createUseStyles({
        icon: {
            ...BASE_ICON,
            ...(iconType && ICON_STYLES[iconType].icon),
            color: color ?? THEME.palette.gray.slate.color,
            ...(iconOnly ? { width: 18, paddingRight: 0 } : {}),
        },
    });
    return useStyles();
};
const BASE_ICON = {
    paddingRight: 8,
};
const ICON_STYLES = {
    glyphicon: {
        icon: {
            top: 2,
            width: 20,
        },
    },
    "glyphicon-pro": {
        icon: {
            width: 24,
            fontSize: 18,
            marginLeft: 0,
        },
    },
};
